import { useMemo } from "react";
import { trpc } from "@/lib/trpc";
import { FiltroDeOrganizacoes, useOrganizacoesMarcadas } from "@/components/shared/FiltroDeOrganizacoes";
import type { ProsthesisOrderRow } from "./types";

/**
 * Os pedidos da lista de Prótese: os da organização ativa ou, no acesso pessoal de quem está em
 * outras organizações, os de todas — com o filtro de organizações de Pacientes (Pessoal primeiro,
 * a escolha lembrada neste navegador).
 */
export function usePedidosDaLista(deTodas: boolean, busca: string) {
  const input = { search: busca.trim() || undefined, take: 200 };
  const daAtiva = trpc.prosthesis.list.useQuery({ ...input, skip: 0 }, { enabled: !deTodas });
  const deTodasQ = trpc.prosthesis.listDeTodasAsOrganizacoes.useQuery(input, { enabled: deTodas });
  const query = deTodas ? deTodasQ : daAtiva;
  const todos = useMemo(() => (query.data?.orders ?? []) as ProsthesisOrderRow[], [query.data]);

  const doFiltro = useMemo(
    () =>
      [...new Map(todos.flatMap((o) => (o.organization ? [[o.organization.id, o.organization] as const] : []))).values()]
        .sort((a, b) => Number(b.isPersonal) - Number(a.isPersonal) || a.name.localeCompare(b.name, "pt-BR"))
        .map((o) => ({ id: o.id, nome: o.isPersonal ? "Pessoal" : o.name, pessoal: o.isPersonal })),
    [todos],
  );
  const filtro = useOrganizacoesMarcadas("protese:filtro-de-organizacoes", doFiltro);
  const orders = useMemo(
    () => (deTodas ? todos.filter((o) => !o.organization || filtro.marcadas.has(o.organization.id)) : todos),
    [deTodas, todos, filtro.marcadas],
  );

  const filtroEl =
    deTodas && doFiltro.length > 1 ? (
      <FiltroDeOrganizacoes organizacoes={doFiltro} {...filtro.controle} />
    ) : null;

  return { orders, isLoading: query.isLoading, isFetching: query.isFetching, filtroEl };
}
